import { Component } from '@angular/core';

import { FrameworkConfigService, FrameworkConfigSettings } from '../fw/services/framework-config.service';
import { MenuService } from '../fw/services/menu.service';
import { initialMenuItems } from './app.menu';

@Component({
    selector: 'app-root',
    template: require('./app.component.html'),
    styles: [require('./app.component.css')]
})
export class AppComponent {

    constructor(private frameworkConfigService: FrameworkConfigService,
        private menuService: MenuService) {

        let config: FrameworkConfigSettings = {
            showLanguageSelector: false,
            showUserControls: true,
            showStatusBar: true,
            showStatusBarBreakpoint: 800
        };

        frameworkConfigService.configure(config);

        menuService.items = initialMenuItems;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/app.component.ts